<template>
  <v-container class="mt-10" fluid>
    <v-row>
      <v-col cols="12" md="2" class="my-1">
        <h2 class="font-weight-thin">Pack Quick Links</h2>
        <h3 class="font-weight-thin">(last 12 months)</h3>
        <pack-quick-links :packList="packList"></pack-quick-links>
      </v-col>
      <v-col cols="12" md="10">
        <search></search>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PackQuickLinks from "@/components/PackQuickLinks";
import Search from "@/components/search";

export default {
  components: {
    PackQuickLinks,
    Search,
  },
  computed: {
    ...mapState({
      currentServiceArea: state => state.session.serviceArea,
      isOchinUser: state => state.session.user.isOchinUser,
      packList: state => state.pack.packList,
    }),
  },
  async created() {
    await this.loadPackList();
  },
  data() {
    return {
      user: null,
    };
  },
  methods: {
    ...mapActions({
      loadPackList: "pack/getList",
    }),
  },
};
</script>
